// extracted by mini-css-extract-plugin
export var paragraph = "infoRows-module--paragraph--1zLfI";
export var paragraph2 = "infoRows-module--paragraph2--sN-JW";
export var word = "infoRows-module--word--3oZsz";
export var loopWrap = "infoRows-module--loopWrap--1R99c";
export var container = "infoRows-module--container--1SNeU";